import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'googleMapsUrl',
})
export class GoogleMapsUrlPipe implements PipeTransform {

    transform(locations: string[], travelMode: string = 'driving'): string {
        if (locations.length === 1) {
            // Position URL
            return `https://www.google.com/maps?q=${ encodeURIComponent(locations[0]) }`;
        } else {
            // Directions URL
            const origin = encodeURIComponent(locations[0]);
            const destination = encodeURIComponent(locations[locations.length - 1]);
            const waypoints = locations.slice(1, -1).map(loc => encodeURIComponent(loc)).join('|');

            return `https://www.google.com/maps/dir/?api=1&origin=${ origin }&destination=${ destination }&waypoints=${ waypoints }&travelmode=${ travelMode }`;
        }
    }
}
